import * as React from 'react';

import {
  ProgressBackground,
  ProgressBarContainer,
  ProgressFill,
} from './styled';

interface DiscountProgressBarProps {
  missing: number;
  threshold: number;
}

export const DiscountProgressBar: React.FC<DiscountProgressBarProps> = ({
  missing,
  threshold,
}) => {
  const progress = ((threshold - missing) / threshold) * 100;

  return (
    <ProgressBarContainer data-testid="discount-progress-bar">
      <ProgressBackground>
        <ProgressFill progress={progress} />
      </ProgressBackground>
    </ProgressBarContainer>
  );
};
